import type { Role } from "../api/types";
import { ROLE_LABELS } from "../api/types";
import { Badge } from "./Badge";

/** Étiquette d'un rôle. Les administrateurs prennent l'accent. */
export function RoleBadge({ role, size = "md" }: { role: Role; size?: "sm" | "md" }) {
  const admin = role === "esn_admin" || role === "admin";
  return (
    <Badge tone={admin ? "accent" : "neutral"} size={size}>
      {ROLE_LABELS[role]}
    </Badge>
  );
}
